export const FIVE_STARS_FEATURE_APP_CONTENT = {
  modelConfiguration: [
    {
      useCarConfigurationService: 'false',
      carlineId: '31120', // 30291 ID.4, 31120 Tiguan
    },
  ],
};
